import { CIMSModule, CIMSPage, Permission } from '@cims-online/shared'
import { useProtectedMenuItem } from './useProtectedMenuItem'
import { UserOutlined } from '@ant-design/icons'

export function useAdmin() {
  return useProtectedMenuItem({
    module: CIMSModule.Admin,
    pages: [
      {
        page: CIMSPage.Users,
        permission: Permission.ViewUser,
        icon: <UserOutlined />,
      },
      {
        page: CIMSPage.Roles,
        permission: Permission.ViewRole,
      },
      {
        page: CIMSPage.CustomFields,
        permission: Permission.ViewCustomField,
      },
      {
        page: CIMSPage.NonUserEmails,
        permission: Permission.ViewNonUserEmail,
      },
      {
        page: CIMSPage.ProjectSettings,
        permission: Permission.ViewProjectSettings,
      },
    ],
  })
}
